"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWatchTrackerApi = void 0;
var axios_1 = require("axios");
var ContentWatchTrackerApi = /** @class */ (function () {
    function ContentWatchTrackerApi(api) {
        this.api = api;
        this.token = '';
        this.requestInterceptorId = 0;
        // ignore empty constructor
    }
    ContentWatchTrackerApi.prototype.setProps = function (props) {
        var instance = ContentWatchTrackerApi.use();
        if (!instance.token)
            instance.token = props.token;
        if (!instance.api)
            return;
        if (instance.requestInterceptorId) {
            instance.api.interceptors.request.eject(instance.requestInterceptorId);
            instance.requestInterceptorId = 0;
        }
        instance.requestInterceptorId = instance.api.interceptors.request.use(function (req) {
            if (req.headers && instance.token) {
                req.headers.Authorization = instance.token;
            }
            return req;
        });
    };
    ContentWatchTrackerApi.use = function (props) {
        if (!ContentWatchTrackerApi._instance) {
            var api = axios_1.default.create({ baseURL: props === null || props === void 0 ? void 0 : props.baseURL });
            ContentWatchTrackerApi._instance = new ContentWatchTrackerApi(api);
        }
        if (props)
            ContentWatchTrackerApi._instance.setProps(props);
        return ContentWatchTrackerApi._instance;
    };
    ContentWatchTrackerApi.getApi = function (props) {
        return ContentWatchTrackerApi.use(props).api;
    };
    return ContentWatchTrackerApi;
}());
exports.ContentWatchTrackerApi = ContentWatchTrackerApi;
